import React from 'react';
import styled, { css } from 'styled-components';
import BlockLink from './BlockLink';

const IconLI = styled.li`
  margin-bottom: 15px;
  padding: 0 10px;
  svg {
    &:hover {
      cursor: pointer;
    }
  }
`;

const IconLink = styled(BlockLink)<{ route?: string; pathname?: string }>`
  ${({ route, pathname, theme }) => {
    const match = route === pathname || `/${pathname.split('/')[1]}` === route;
    return css`
      border-radius: 15px;
      background-color: ${match && theme.colors.greyLightest};
      color: ${match ? theme.colors.black : theme.colors.sideBarLI};
      svg {
        &:hover {
          cursor: pointer;
        }
      }
    `;
  }}
`;

interface IconListItemProps {
  option: {
    route: string;
    name: string;
    icon: React.ReactNode;
  };
  pathname: string;
}

const IconListItem = ({
  option: { route, name, icon },
  pathname,
}: IconListItemProps) => (
  <IconLI>
    <IconLink title={name} route={route} pathname={pathname} to={route}>
      {icon}
    </IconLink>
  </IconLI>
);

export default IconListItem;
